import {useMutation} from "@tanstack/react-query";

export const findIdByEmail = async (name, email, authNumber, timeStamp) => {
    const response = await fetch('/api/find-id/email', {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(name, email, authNumber, timeStamp ),
    });
    // const response = await AxiosConfig.post("/api/find-id/email", JSON.stringify({ name, email, authNumber, timeStamp }), {
    //     headers: {
    //         "Content-Type": "application/json",
    //     },
    // });

    const data = await response.json();

    return data;
};

export const findIdByPhone = async (name, phoneNumber, authNumber, timeStamp) => {
    const response = await fetch('/api/find-id/phone', {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(name, phoneNumber, authNumber, timeStamp ),
    });
    const data = await response.json();
    return data;
};

// 실제 인증번호 발송 요청 api
export const verifyPhone = async ({phoneNumber}) => {
    /* 회원 있을 시 문자인증 보내는 api 사용 */
    const response = await fetch("/api/members/phone/certification/duplicate", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ phoneNumber }),
    });
    // const response = await AxiosConfig.post("/api/members/phone/certification/duplicate", JSON.stringify({ phoneNumber }), {
    //     headers: {
    //         "Content-Type": "application/json",
    //     },
    // });

    const data = await response.json();
    console.log(response.ok ? "전화번호 인증 요청 성공" : "전화번호 인증 요청 실패", data);
    if (data.result === "noUser") {
        throw new Error(data.message || "가입되지 않은 회원입니다.");
    }
    if (!response.ok) {
        throw new Error(data.message || "전화번호 인증 요청에 실패했습니다.");
    }
    return data;
};

// 실제 이메일 인증번호 발송 요청 api
export const verifyEmail = async ({name ,email}) => {
    /* 회원 있을 시 이메일 보내는 api 사용 */
    const response = await fetch("/api/members/email/certification/duplicate", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ name, email }),
    });
    // const response = await axios.post("/api/members/email/certification/duplicate",
    //     JSON.stringify({ name, email }), {
    //         headers: {
    //             "Content-Type": "application/json",
    //         },
    //     });

    const data = await response.json();
    console.log(response.ok ? "이메일 인증 요청 성공" : "이메일 인증 요청 실패", data);
    if (data.result === "noUser") {
        throw new Error(data.message || "가입되지 않은 회원입니다.");
    }
    if (!response.ok) {
        throw new Error(data.message || "이메일 인증 요청에 실패했습니다.");
    }
    return data;
};

// verifyPhoneMutation 설정. 인증번호 발송 요청 시 사용
export const useVerifyPhoneMutation = () => {
    return useMutation({
        mutationFn: verifyPhone,
        onSuccess: (data) => {

            if (data.result === "noUser") {
                throw new Error(data.message || "가입되지 않은 회원입니다.");
            }
            console.log("전화번호 인증 요청 성공:", data);
        },
        onError: (error) => {
            console.error("전화번호 인증 요청 실패:", error);
            throw error;
        },
    });
};

// ID 찾기 mutation 설정, 전화번호로 ID 찾기 시 사용
export const useFindIdMutation = () => {
    return useMutation({
        mutationFn: findIdByPhone,
        onSuccess: (data) => {
            console.log("ID 찾기 성공:", data);

            return data;
        },
        onError: (error) => {
            console.error("ID 찾기 실패:", error);
            throw error;
        },
    });
};

// verifyPhoneMutation 설정. 이메일 인증번호 발송 요청 시 사용
export const useVerifyEmailMutation = () => {
    return useMutation({
        mutationFn: verifyEmail,
        onSuccess: (data) => {

            if (data.result === "noUser") {
                throw new Error(data.message || "가입되지 않은 회원입니다.");
            }
            console.log("전화번호 인증 요청 성공:", data);
        },
        onError: (error) => {
            console.error("전화번호 인증 요청 실패:", error);
            throw error;
        },
    });
}

// ID 찾기 mutation 설정, 이메일로 ID 찾기 시 사용
export const useFindIdByEmailMutation = () => {
    return useMutation({
        mutationFn: findIdByEmail,
        onSuccess : (data) => {
            console.log("ID 찾기 성공:", data);

            return data;
        },
        onError   : (error) => {
            console.error("ID 찾기 실패:", error);
            throw error;
        },
    });
};

// ✅ 이메일 인증번호 발송 요청
// export const verifyEmail = async ({ name, email }) => {
//     const response = await fetch("/api/members/email/certification/duplicate", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ name, email }),
//     });
//
//     const data = await response.json();
//     if (!response.ok) throw new Error(data.message || "이메일 인증 요청 실패");
//     return data;
// };

// ✅ 이메일 인증번호 검증 요청
export const confirmEmailVerification = async ({ email, authCode, timeStamp }) => {
    const response = await fetch("/api/members/email/confirm", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, authCode, timeStamp }),
    });

    const data = await response.json();
    if (!response.ok) throw new Error(data.message || "이메일 인증 실패");
    return data;
};

// ✅ 이메일 인증 확인 Mutation
export const useConfirmEmailMutation = () => {
    return useMutation({
        mutationFn: confirmEmailVerification,
        onSuccess: (data) => console.log("이메일 인증 성공:", data),
        onError: (error) => console.error("이메일 인증 실패:", error),
    });
};

// 비밀번호 변경 요청
export const changePassword = async ({ loginId, newPassword, newPasswordConfirm }) => {
    const response = await fetch("/api/modify-pw", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ loginId, newPassword, newPasswordConfirm }),
    });

    const data = await response.json();
    if (!response.ok) throw new Error(data.message || "비밀번호 변경 실패");
    return data;
};

// ✅ 비밀번호 변경 Mutation
export const useChangePasswordMutation = () => {
    return useMutation({
        mutationFn: changePassword,
        onSuccess: (data) => console.log("비밀번호 변경 성공:", data),
        onError: (error) => console.error("비밀번호 변경 실패:", error),
    });
}